import React, { useState } from 'react';
import GenericTable from './GenericTable';

// const PaymentsManagementExample = ({ columns, defaultRows, searchText, onRowSelect = ()=>{} }) => {
  const PaymentsManagementExample = ({ columns, defaultRows, searchText, onRowSelect, currentPage, rowsPerPage, onPageChange, onRowsPerPageChange }) => {

  // אתחול המצב עם הערכים שמתקבלים מהפרופס
  const [paymentRows, setPaymentRows] = useState(defaultRows);

  const handlePaymentsChange = (newRows) => {
    setPaymentRows(newRows);
  };

  // פונקציה ליצירת מבנה של שורה
  const createRowStructure = (columns) => {
    return columns.reduce((acc, column) => {
      acc[column.field] = '';
      return acc;
    }, {});
  };

  return (
    <div>
      {columns && defaultRows && (
        <GenericTable
        columns={columns}
        defaultRows={paymentRows}
        searchText={searchText}
        onRowsChange={handlePaymentsChange}
        rowStructure={createRowStructure(columns)}
        onRowSelect={onRowSelect}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
      )}
    </div>
  );
};

export default PaymentsManagementExample;
